import React from "react";
import DrawerHeader from "../Elements/DrawerHeader";
import VehicleInfo from "../Elements/VehicleInfo";
import "../DrawerWrapper.scss";

interface Props {
    title?: string;
    translateTitle?: boolean;
    vin?: string;
    children: any;
}

const DrawerWrapper = ({ children, title, translateTitle, vin }: Props) => {
    return (
        <div className={`drawer_wrapper`}>
            <DrawerHeader title={title} translateTitle={translateTitle} />
            <div className={`drawer_content`}>
                <div className={`drawer_scroll`}>
                    {!!vin && <VehicleInfo vin={vin} />}
                    {children}
                </div>
            </div>
        </div>
    );
};

export default DrawerWrapper;
